import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { confirmAlert } from "react-confirm-alert"
import { validateForm } from "../../../../../../services/validation"
import { saveMyGoals } from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import Tooltip from "../../../../../../components/Tooltip"
import Form, { Group, Input, TextArea } from "../../../../../../components/Form"
import Repeater from "../../../../components/Repeater"
import Button from "../../../../../../components/Button"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardDescription,
  InfoCardLabel
} from "../../../../components/InfoCard"
import RequestSupport from "../../../../components/RequestSupport"

class MyGoals extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      goals: [],
      form: {
        title: {
          label: "What Is Your Goal",
          name: "title",
          type: "text",
          value: "",
          required: true
        },
        content: {
          label: "Describe Your Goal",
          name: "content",
          type: "textarea",
          value: "",
          required: true
        }
      },
      isSubmitted: false,
      formIsHidden: true,
      currentId: null,
      requestSupportIsHidden: true
    }
  }

  componentDidMount() {
    this.updateMyGoals()
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.myGoals) {
      if (
        JSON.stringify(prevProps.store.plan.answers.myGoals) !==
        JSON.stringify(plan.answers.myGoals)
      ) {
        this.updateMyGoals()
      }
    }
  }

  requestSupportToggle = () => {
    const { requestSupportIsHidden } = this.state

    this.setState({ requestSupportIsHidden: !requestSupportIsHidden })
  }

  updateMyGoals = () => {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.myGoals) {
      this.setState(
        {
          goals: plan.answers.myGoals.goal
        },
        () => {
          this.openFormByUrlParameter()
        }
      )
    }
  }

  openFormByUrlParameter = () => {
    const {
      id,
      history,
      store: { plan }
    } = this.props

    if (id !== undefined && plan.answers.myGoals) {
      plan.answers.myGoals.goal.map(item => {
        if (id === item.id) {
          history.push("/pre-plan/my-goals")
          this.onFormOpen(null, item.id, item)
        }

        return null
      })
    }
  }

  handleNext = () => {
    const { onNext } = this.props
    onNext()
  }

  handleBack = () => {
    const { onBack } = this.props
    onBack()
  }

  getItem = id => {
    const { form } = this.state

    return {
      id: id || null,
      title: form.title.value,
      content: form.content.value
    }
  }

  scrollToInvalidElement = fields => {
    Object.keys(fields).map((resKey, index) => {
      if (fields[resKey].message && index === 0) {
        const item = this.form.elements[resKey]
        const parent = item.closest
          ? item.closest(".form_group")
          : item[0].closest(".form_group")
        const offSet = parent.getBoundingClientRect().top + window.pageYOffset
        const supportsNativeSmoothScroll =
          "scrollBehavior" in document.documentElement.style

        if (supportsNativeSmoothScroll) {
          window.scrollTo({
            top: offSet,
            behavior: "smooth"
          })
        } else {
          window.scrollTo(0, offSet)
        }
      }

      return null
    })
  }

  removeItem = index => {
    const { goals } = this.state
    const {
      onSaveMyGoals,
      store: { user, plan }
    } = this.props

    const newGoals = goals.filter(item => {
      const goal = item

      if (item.id === index) {
        return false
      }

      return goal
    })

    const deleteItem = () => {
      onSaveMyGoals(user.token, plan.id, newGoals).then(() => {
        this.setState({
          formIsHidden: true
        })
      })
    }

    confirmAlert({
      title: "Are you sure?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            deleteItem()
          }
        },
        {
          label: "No"
        }
      ]
    })
  }

  changeItem = () => {
    const { goals, form, currentId } = this.state
    const {
      scrollToNav,
      onSaveMyGoals,
      store: { user, plan }
    } = this.props

    const res = validateForm(form)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      const newItem = this.getItem(currentId)
      let newGoals

      if (currentId !== null) {
        newGoals = goals.map(item => {
          let goal = item

          if (item.id === currentId) {
            goal = newItem
          }

          return goal
        })
      } else {
        newGoals = [...goals, newItem]
      }

      scrollToNav()

      onSaveMyGoals(user.token, plan.id, newGoals).then(() => {
        this.setState({
          formIsHidden: true
        })
      })
    } else {
      this.scrollToInvalidElement(res)

      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...res
        }
      })
    }
  }

  onFormOpen = (e, index, item) => {
    if (e) e.preventDefault()

    const { goals, form } = this.state
    const { scrollToNav } = this.props

    const newForm = {}
    let currentId
    let value
    let res

    if (item) {
      currentId = index
      res = item
    } else if (index) {
      currentId = index
      res = goals.find(({ id }) => {
        return index === id
      })
    } else {
      currentId = null
    }

    Object.keys(form).map(key => {
      const ValueTypeOf = typeof form[key].value === "string" ? "" : []

      if (!index) {
        value = ValueTypeOf
      } else if (res) {
        value = res[key]
      } else {
        value = ValueTypeOf
      }

      newForm[key] = {
        ...form[key],
        value
      }

      return null
    })

    scrollToNav()

    this.setState({
      formIsHidden: false,
      currentId,
      form: newForm
    })
  }

  onFormClose = () => {
    const { scrollToNav } = this.props

    scrollToNav()

    this.setState({
      formIsHidden: true,
      currentId: null,
      requestSupportIsHidden: true
    })
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  render() {
    const {
      form,
      formIsHidden,
      isSubmitted,
      goals,
      currentId,
      requestSupportIsHidden
    } = this.state
    const {
      store: { plan, user }
    } = this.props

    const userIsGuardian = user.list_role.includes(configs.roles.Guardian)

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">Setting Goals</div>
          <div className="pre-plan_description">
            Setting goals is a process and starts with careful consideration of
            what you want to achieve. You put in supports and structures to help
            along the way and then work to achieve them. Some goals may be short
            term. Others may be long term. It would be helpful to discuss and
            explore your goals with your support team, LAC and Planner.
            Remember, together is better.
          </div>
        </div>

        {plan.loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <div className="row my-goals">
            <div className="col-xl-8 offset-xl-2">
              <Form
                formRef={el => {
                  this.form = el
                }}
              >
                {formIsHidden ? (
                  <>
                    {goals.map(userG => (
                      <InfoCard
                        key={userG.id}
                        className="info-card--yellow-light"
                        hideDelete={userIsGuardian}
                        onDelete={() => {
                          this.removeItem(userG.id)
                        }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <InfoCardItem>
                              <InfoCardLabel>Goal</InfoCardLabel>
                              <InfoCardTitle>{userG.title}</InfoCardTitle>
                            </InfoCardItem>
                          </div>

                          <div className="col-md-8">
                            <InfoCardItem>
                              <InfoCardLabel>Description</InfoCardLabel>
                              <InfoCardDescription>
                                {userG.content}
                              </InfoCardDescription>
                            </InfoCardItem>
                          </div>
                        </div>
                        <Group className="form_btn-group form_group--padding-top-lg">
                          <Button
                            button={{ type: "button" }}
                            onClick={e => {
                              this.onFormOpen(e, userG.id)
                            }}
                            className="btn--secondary-light btn--width-lg btn--height-md"
                          >
                            Edit Support Goal
                          </Button>
                          <Button
                            button={{ type: "button" }}
                            onClick={e => {
                              this.onFormOpen(e, userG.id)
                            }}
                            className="btn--cancel-light btn--request-support btn--width-lg btn--height-md"
                          >
                            Request Support
                          </Button>
                        </Group>
                      </InfoCard>
                    ))}

                    {!userIsGuardian && (
                      <Group>
                        <Repeater text="Add A Goal" onClick={this.onFormOpen} />
                      </Group>
                    )}

                    <Group className="form_btn-group form_group--padding-top-lg text-center">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.handleBack}
                        className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Back
                      </Button>

                      <Button
                        button={{ type: "button" }}
                        onClick={this.handleNext}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Next
                      </Button>
                    </Group>
                  </>
                ) : (
                  <>
                    <div className="pre-plan_form_header">
                      <div className="pre-plan_form_title">Your Goal</div>
                      <div className="pre-plan_form_description">
                        Let us know what you want to achieve that will help you
                        improve the quality of your life.
                      </div>
                    </div>
                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.title}
                      />
                    </Group>

                    <Group className="form_group--with-tooltip">
                      <Tooltip>
                        Tell us about the details around your goal and how NDIS
                        can support you so that you can achieve this goal.
                      </Tooltip>

                      <TextArea
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.content}
                      />
                    </Group>

                    <Group className="form_btn-group form_group--padding-top-lg">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.onFormClose}
                        className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Back
                      </Button>

                      <Button
                        button={{ type: "button", disabled: userIsGuardian }}
                        onClick={this.changeItem}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        {currentId === null
                          ? "Add Your Goal"
                          : "Edit Your Goal"}
                      </Button>

                      {currentId !== null && (
                        <Button
                          button={{ type: "button" }}
                          onClick={this.requestSupportToggle}
                          className={`
                            btn--cancel-light 
                            btn--request-support 
                            btn--width-md 
                            btn--height-sm 
                            btn--font-size-md 
                            ${
                              !requestSupportIsHidden
                                ? "btn--request-support-active"
                                : ""
                            }
                            `}
                        >
                          Request Support
                        </Button>
                      )}
                    </Group>
                  </>
                )}
              </Form>

              {plan.answers.supportTeam && currentId && (
                <RequestSupport
                  guardians={plan.answers.supportTeam}
                  planSection="MG"
                  planSubsection={currentId}
                  isHidden={requestSupportIsHidden}
                  onToggle={this.requestSupportToggle}
                />
              )}
            </div>
          </div>
        )}
      </>
    )
  }
}

MyGoals.propTypes = {
  onBack: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  onSaveMyGoals: propTypes.func.isRequired,
  scrollToNav: propTypes.func.isRequired,
  id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        supportTeam: propTypes.arrayOf(propTypes.shape({})),
        myGoals: propTypes.shape({
          goal: propTypes.arrayOf(
            propTypes.shape({
              title: propTypes.string,
              content: propTypes.string
            })
          )
        })
      })
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveMyGoals: (token, planId, activities) =>
    dispatch(saveMyGoals(token, planId, activities))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyGoals))
